import { render } from 'inferno';
import { createElement } from 'inferno-create-element';
export function renderTemplate(template, props, _component) {
  setTimeout(function () {
    var _a;

    render(createElement(template, props), (_a = props.container) === null || _a === void 0 ? void 0 : _a.get(0));
  }, 0);
}
export var hasTemplate = function hasTemplate(name, properties, _component) {
  return !!properties[name];
};